import apiService from './api';

export interface RedisAdminStatus {
  enabled: boolean;
  connected: boolean;
  mode: 'real' | 'mock';
  connection: {
    via: 'socket' | 'url' | 'tcp';
    socketPathPresent: boolean;
    urlPresent: boolean;
    host: string;
    port: number;
  };
  ping: string | null;
  dbSize: number | null;
  info?: {
    redis_version?: string;
    used_memory_human?: string;
    connected_clients?: string;
    uptime_in_seconds?: string;
  };
}

class RedisAdminService {
  private baseUrl = '/admin/redis';

  async getStatus(): Promise<RedisAdminStatus> {
    const data = await apiService.get<RedisAdminStatus>(`${this.baseUrl}/status`);
    return data;
  }

  async flushDb(): Promise<{ message?: string }> {
    const res = await apiService.post<{ status?: string; message?: string }>(`${this.baseUrl}/flush`, {});
    return { message: (res as any)?.message };
  }
}

export default new RedisAdminService();


